import { render } from "./NewsComp.vue?vue&type=template&id=0dc2cd96"
import script from "./NewsComp.vue?vue&type=script&lang=js"
export * from "./NewsComp.vue?vue&type=script&lang=js"

import "./NewsComp.vue?vue&type=style&index=0&id=0dc2cd96&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__